import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMenuProduct } from "src/models/POS/MenuProduct.models";

interface MenuProductState {
  menuProducts: IMenuProduct[];
  menuProductToEdit: IMenuProduct | null;
}

const initialState: MenuProductState = {
  menuProducts: [],
  menuProductToEdit: null,
};

const menuProductSlice = createSlice({
  name: "MenuProduct",
  initialState,
  reducers: {
    setMenuProductList: (state, action: PayloadAction<IMenuProduct[]>) => {
      state.menuProducts = action.payload;
    },
    setMenuProductToEdit: (
      state,
      action: PayloadAction<IMenuProduct | null>
    ) => {
      state.menuProductToEdit = action.payload;
    },
    concatListMenuProduct: (
      state: MenuProductState,
      action: PayloadAction<IMenuProduct[]>
    ) => {
      state.menuProducts = [...state.menuProducts.concat(action.payload)];
    },
    addMenuProduct: (state, action: PayloadAction<IMenuProduct>) => {
      state.menuProducts.push(action.payload);
    },
    updateMenuProduct: (state, action: PayloadAction<IMenuProduct>) => {
      let itemIndex = state.menuProducts.findIndex(
        item => item.menuProductId === action.payload.menuProductId
      );
      if (itemIndex !== -1) state.menuProducts[itemIndex] = action.payload;
    },
    deleteMenuProduct: (state, action: PayloadAction<number>) => {
      const newArray = state.menuProducts.filter(
        item => item.menuProductId !== action.payload
      );
      state.menuProducts = newArray;
    },
  },
});

export const {
  setMenuProductList,
  concatListMenuProduct,
  setMenuProductToEdit,
  addMenuProduct,
  updateMenuProduct,
  deleteMenuProduct,
} = menuProductSlice.actions;

export default menuProductSlice.reducer;
